import React from 'react'

import { CustomerText } from './../CustomerText'
import QuestionDetailCom from './../Components/QuestionDetailCom'
import QuestionHelp from './Components/QuestionHelp'
import Config from '../Config'
import Icons from './Images'
import Pagination from './Components/Pagination'
const { Language, platform, Pushgtagpiwikurl, Pushgtagdata } = Config()

const tempText = CustomerText[Language]

export default class QuestionDetail extends React.Component {
    constructor(props) {
        super(props)
        this.state = {

        }
    }

    renderContent({ title, content, flag = false }) {
        return <div className='questionContentBox'>
            <div className="contentTitle">{title}</div>
            <div
                className="contentWrap"
                //style={{ maxHeight: flag ? '9999px' : '0' }}
                style={{ display: flag ? 'block' : 'none' }}
                dangerouslySetInnerHTML={{
                    __html: content
                }}
            ></div>
        </div>
    }


    render() {
        let { tempCategories, RouterFeedback, knowledgeBaseID, onLeft, categories, RouterDetail, toggleSearchQuestion, routerName, RouterSearch } = this.props
        //let { articles } = tempCategories
        let tempArticles = tempCategories?.articles

        return <div className="questionDetailContainer">
            <QuestionDetailCom
                routerName={routerName}
                knowledgeBaseID={knowledgeBaseID}
                tempCategories={tempCategories}
                categories={categories}
                Content={({
                    getCategoriesDetail,
                    questionIndex,
                    changePaginationIndex,
                    currentPaginationIndex,
                    PageSize
                }) => {
                    let articles = tempArticles?.slice(PageSize * (currentPaginationIndex - 1), PageSize * (currentPaginationIndex - 1) + PageSize)
                    let flag = (Array.isArray(articles) && !!articles.length)
                    return <>
                        {
                            flag && questionIndex >= 0 && platform == 'Mobile' && <>
                                <div className="detailNavBox">
                                    <div className="detailNav" onClick={() => {
                                        onLeft('QuestionDetail')
                                    }}>
                                        <div className="detailNavText1">{tempText?.text1}</div>
                                        <div className="arrowIcon rightArrow1" />
                                    </div>

                                    <div className="detailNav" onClick={() => {
                                        getCategoriesDetail({ isBack: true })
                                        RouterDetail({ routerName: 'QuestionDetail' })
                                    }}>
                                        <div className="detailNavText1">{tempCategories?.categoryName}</div>
                                        <div className="arrowIcon rightArrow1" />
                                    </div>

                                    <div className="detailNav">
                                        <div className="detailNavText2">{articles[questionIndex]?.title}</div>
                                    </div>
                                </div>

                                {
                                    this.renderContent({
                                        title: articles[questionIndex]?.title,
                                        content: articles[questionIndex]?.content,
                                        flag: true
                                    })
                                }
                            </>
                        }

                        {
                            (platform == 'Mobile' ? (questionIndex < 0) : true) &&
                            <>
                                <QuestionHelp
                                    tempText={tempText}
                                    RouterFeedback={RouterFeedback}
                                    fromPage='QuestionDetail'
                                ></QuestionHelp>

                                {
                                    flag
                                        ?
                                        <div className="knowledgeCategoriesBox">
                                            <div style={{ overflow: 'hidden', borderRadius: '8px' }}>
                                                {
                                                    articles.map((v, i) => {
                                                        return <div key={i} className='knowledgeCategoriesListBox'>
                                                            <div
                                                                onClick={() => {
                                                                    getCategoriesDetail({
                                                                        knowledgeBaseID: v.knowledgeBaseID,
                                                                        questionIndex: i,
                                                                        isShow: !v?.isShow
                                                                    })
                                                                    Pushgtagpiwikurl('help_center', 'Help Center')
                                                                    Pushgtagdata('HelpCenter', 'View FAQ Article', 'HelpCenter_C_FAQArticle', false,
                                                                        [
                                                                            {
                                                                                customVariableKey: "HelpCenter_C_FAQArticleTitle",
                                                                                customVariableValue: v?.title
                                                                            }
                                                                        ]
                                                                    )
                                                                    platform == 'Mobile' && RouterDetail({ routerName: `QuestionDetail/isBackPage`, piwikTitle: v.title })
                                                                }}
                                                                className="knowledgeCategoriesList">
                                                                <div className="knowledgeCategoriesText">{v?.title}</div>

                                                                {/* <div
                                                                className="arrowIcon"
                                                                style={{
                                                                    transform: platform == 'Web' && `rotate(${v?.isShow ? 135 : -45}deg)`,
                                                                }}
                                                            /> */}
                                                                <img
                                                                    src={Icons.rightArrow}
                                                                    className='rightArrow'
                                                                    style={{
                                                                        transform: platform == 'Web' && `rotate(${v?.isShow ? -90 : 90}deg)`,
                                                                    }}
                                                                ></img>
                                                            </div>

                                                            {
                                                                platform == 'Web' &&
                                                                this.renderContent({
                                                                    title: v.title,
                                                                    content: v?.content,
                                                                    flag: !!v?.content && v?.isShow
                                                                })
                                                            }
                                                        </div>
                                                    })
                                                }
                                            </div>
                                            {
                                                flag && tempArticles.length > PageSize && platform == 'Mobile' &&
                                                <div style={{ marginTop: '15px' }}>
                                                    <Pagination
                                                        changePaginationIndex={changePaginationIndex}
                                                        totalPaginationNum={Math.ceil(tempArticles.length / PageSize)}
                                                        currentPaginationIndex={currentPaginationIndex}
                                                    ></Pagination>
                                                </div>
                                            }
                                        </div>
                                        :
                                        <div className="noDataBox">
                                            <img
                                                src={Icons.noData}
                                                className="noDataImg"
                                            ></img>
                                            <div className="noDataText">{tempText?.text44}</div>
                                        </div>
                                }
                            </>
                        }

                        {
                            flag && tempArticles.length > PageSize && platform == 'Web' &&
                            <div style={{ marginTop: '15px' }}>
                                <Pagination
                                    changePaginationIndex={changePaginationIndex}
                                    totalPaginationNum={Math.ceil(tempArticles.length / PageSize)}
                                    currentPaginationIndex={currentPaginationIndex}
                                ></Pagination>
                            </div>
                        }
                    </>
                }}
            ></QuestionDetailCom>
        </div>
    }
}